export default "__VITE_PUBLIC_ASSET__80e3ba85__"